import MonthlyViewScreen from './MonthlyViewAntd'

export default MonthlyViewScreen
